import { __awaiter, __generator } from "tslib";
import { WIX_ECOM } from '@wix/app-definition-ids';
import { QuickViewActions } from '../../../../actions/QuickViewActions/QuickViewActions';
import { getCartIconControllerConfig } from '../../../wixcode/internalOnlineStoresOnly/getCartIconControllerConfig';
import { getSlugByProductId } from './common/getSlugByProductId';
var getCartIconData = function (context, isOnlineStoresViewerScript) { return __awaiter(void 0, void 0, void 0, function () {
    var ecomPublicApi, cartIconControllerConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isOnlineStoresViewerScript) return [3 /*break*/, 2];
                return [4 /*yield*/, context.wixAPI.site.getPublicAPI(WIX_ECOM)];
            case 1:
                ecomPublicApi = _a.sent();
                return [2 /*return*/, ecomPublicApi.__internalOnlineStoresOnly.getCartIconCompIdAndExternalId()];
            case 2:
                cartIconControllerConfig = getCartIconControllerConfig(context);
                return [2 /*return*/, cartIconControllerConfig
                        ? { compId: cartIconControllerConfig.compId, externalId: cartIconControllerConfig.config.externalId }
                        : undefined];
        }
    });
}); };
export var openQuickView = function (_a) {
    var context = _a.context, origin = _a.origin, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return function (productId, options) { return __awaiter(void 0, void 0, void 0, function () {
        var cartIconData, compId, externalId, slug;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (context.siteStore.isMobile()) {
                        throw Error('Cannot open quick-view in mobile');
                    }
                    return [4 /*yield*/, getCartIconData(context, isOnlineStoresViewerScript)];
                case 1:
                    cartIconData = _a.sent();
                    if (!cartIconData) {
                        throw Error('Cannot use openQuickView() without cart-icon on site');
                    }
                    compId = cartIconData.compId, externalId = cartIconData.externalId;
                    return [4 /*yield*/, getSlugByProductId(productId, { context: context, origin: origin })];
                case 2:
                    slug = _a.sent();
                    return [2 /*return*/, new QuickViewActions(context.siteStore).quickViewProduct({
                            origin: origin,
                            urlPart: slug,
                            compId: compId,
                            externalId: externalId,
                            selectionIds: [],
                            quantity: options === null || options === void 0 ? void 0 : options.quantity,
                        })];
            }
        });
    }); };
};
//# sourceMappingURL=openQuickView.js.map